// extracted by mini-css-extract-plugin
module.exports = {"systemMessage":"widget-space--systemMessage--1GYiU"};